import { Deserializable } from './deserializable.interface';
import { Permission } from './permission.model';
import { JsonProperty, JsonObject } from 'typescript-json-serializer';

/**
 * Role of the user in the group
 */
export enum GroupRole {
  Member = 'group-member',
  Admin = 'group-admin',
}

/**
 * Container class for user group member
 *
 * @export
 * @class UserGroupMember
 */
@JsonObject()
export class UserGroupMember {
  @JsonProperty('Id') id: string;
  @JsonProperty('Username') username: string;
  @JsonProperty({ name: 'GroupPermissions', type: Permission }) groupPermissions: Array<Permission>;

  get role(): GroupRole {
    // Check if user is an admin
    if (this.groupPermissions.some((p) => p.type === 'administrate-group')) {
      return GroupRole.Admin;
    }

    return GroupRole.Member;
  }
}
